module.exports = __webpack_public_path__ + "img/sign-76.50d12e3f.jpg";